import { Link } from "wouter";
import { Trophy, Facebook, Instagram, Mail, Phone, MapPin } from "lucide-react";
import prizeDropLogo from "@assets/logo2 5 (1)_1756807002986.png";

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white mt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="mb-4">
              <h3 className="text-2xl font-bold text-white mb-2">PrizeDrop</h3>
            </div>
            <p className="text-gray-400 mb-4">
              Your trusted platform for exciting competitions and fantastic prizes.
            </p>
          </div>

          {/* Competitions */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Competitions</h4>
            <ul className="space-y-2 text-gray-400">
              <li>
                <Link href="/competitions?type=daily" className="hover:text-white transition-colors">
                  Daily Competitions
                </Link>
              </li>
              <li>
                <Link href="/competitions?type=weekly" className="hover:text-white transition-colors">
                  Weekly Prizes
                </Link>
              </li>
              <li>
                <Link href="/challenges" className="hover:text-white transition-colors">
                  Challenges
                </Link>
              </li>
            </ul>
          </div>

          {/* Social Media */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Follow Us</h4>
            <ul className="space-y-2 text-gray-400">
              <li>
                <a href="https://www.facebook.com/profile.php?id=61578226929455" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors flex items-center gap-2">
                  <Facebook className="h-4 w-4" />
                  Facebook
                </a>
              </li>
              <li>
                <a href="https://www.instagram.com/prize_drop/" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors flex items-center gap-2">
                  <Instagram className="h-4 w-4" />
                  Instagram
                </a>
              </li>
            </ul>
          </div>

          {/* Legal & Contact */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Legal</h4>
            <ul className="space-y-2 text-gray-400 mb-6">
              <li>
                <Link href="/terms" className="hover:text-white transition-colors">
                  Terms & Conditions
                </Link>
              </li>
              <li>
                <Link href="/privacy" className="hover:text-white transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link href="/disclaimer" className="hover:text-white transition-colors">
                  Disclaimer
                </Link>
              </li>
            </ul>


          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
          <p>&copy; 2025 Prize Drop. All rights reserved.</p>
          <p className="mt-2 text-sm">
            Built with passion for competition enthusiasts worldwide.
          </p>
        </div>
      </div>
    </footer>
  );
}
